import * as React from "react";
import type { SVGProps } from "react";
const SvgRadio = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 5.999H9.19l5.18-2.07c.51-.21.76-.79.56-1.3s-.79-.76-1.3-.56l-9.37 3.75A1.99 1.99 0 0 0 3 7.679v11.32c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-11c0-1.1-.9-2-2-2m0 2v3H8v-1c0-.55-.45-1-1-1s-1 .45-1 1v1H5v-3zm-14 11v-6h14v6zm12-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.56-.45-1-1-1m-5 1c0-.55.45-1 1-1s1 .44 1 1c0 .55-.45 1-1 1s-1-.45-1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRadio;
